import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import {
  REPORT_CANVAS_ROUTE_PATH,
  buildStudyReportRouteState,
  buildStudyReportSearch,
} from 'components/Pages/StudyReport/studyReportRouteNavigation';
import { isEmpty } from 'lodash';
import { useEncodedFilters } from 'utils/useEncodedFilters';

export const useOpenStudyReportRoute = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { queryParams } = useEncodedFilters();

  return React.useCallback(
    (options?: {
      initialUserPrompt?: string;
      keepDrawerOpen?: boolean;
      sessionId?: string;
      studyIds?: string[];
      activeStudyId?: string | null;
      labId?: string | null;
    }) => {
      const effectiveLabId = options?.labId ?? queryParams.labId;
      const effectiveStudyIds = !isEmpty(options?.studyIds)
        ? options.studyIds
        : options?.activeStudyId
        ? [options.activeStudyId]
        : undefined;
      const effectiveFilters = !isEmpty(effectiveStudyIds)
        ? { studyId: effectiveStudyIds.length === 1 ? effectiveStudyIds[0] : effectiveStudyIds }
        : queryParams.filters;
      const baseSearch = buildStudyReportSearch({
        labId: effectiveLabId,
        filters: effectiveFilters,
        sessionId: options?.sessionId,
        studyIdsOverride: effectiveStudyIds,
      });
      const search = options?.keepDrawerOpen ? `${baseSearch}${baseSearch ? '&' : '?'}copilotDrawerOpen=1` : baseSearch;

      navigate(
        {
          pathname: REPORT_CANVAS_ROUTE_PATH,
          search,
        },
        {
          state: buildStudyReportRouteState({
            filters: effectiveFilters,
            labId: effectiveLabId,
            initialUserPrompt: options?.initialUserPrompt,
            location,
            existingState: location.state,
          }),
        }
      );
    },
    [location, navigate, queryParams.filters, queryParams.labId]
  );
};
